import React, { useContext } from 'react';

import FormInputChangesWrapper from './FormInputChangesWrapper';
import { useFormSelector } from '../../custom-hooks';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { getUITA } from '../../utils/commonUtils';
import { FORM_KEYS, SS_CONTROL_TYPE } from '../constants/form-manager.constants';
import { FormContext, SubGridContext } from '../context';
import { getIsFormChangesMode } from '../selectors/common.selectors';
import { getIsSiblingSsZoomStandalone, isChildrenHidden } from '../selectors/runtime.selectors';
import { getFlexValue } from '../utils/common.utils';

const FormInput = ({
  children,
  maxWidth = 568,
  width = '100%',
  inTable,
  isInHeader,
  inFieldGroup,
  controlType,
  id,
  parentType,
  index,
  ...formChangesModeProps
}) => {
  const { isMobileDevice } = useWindowDimensions();
  const isSiblingSsZoomStandalone = useFormSelector(getIsSiblingSsZoomStandalone, { id });
  const isHiddenChildren = useFormSelector(isChildrenHidden, { id, index });
  const isFormChangesMode = useFormSelector(getIsFormChangesMode);
  const inSubGrid = useContext(SubGridContext);
  const formKey = useContext(FormContext);

  const isEditor = formKey === FORM_KEYS.EDITOR;
  const isAdvancedTextBox = controlType === SS_CONTROL_TYPE.ADVANCED_TEXT_BOX;

  const inSubGridOrMobile = inSubGrid || isMobileDevice;
  const disableMaxWidth =
    isEditor ||
    (isAdvancedTextBox && !inSubGridOrMobile && !inTable) ||
    controlType === SS_CONTROL_TYPE.CHECK_BOX;
  const disableWidth =
    (inTable && controlType === SS_CONTROL_TYPE.TEXT_VIEW) || inFieldGroup || isInHeader;

  if (isSiblingSsZoomStandalone) {
    return (
      <FormInputChangesWrapper id={id} {...formChangesModeProps}>
        <div
          style={{
            marginRight: inTable && 10,
          }}
          ui-ta={getUITA('SSSegmentFieldSet')}
          data-ss-id={id}
        >
          {children}
        </div>
      </FormInputChangesWrapper>
    );
  }

  if (
    children.props.controlType === SS_CONTROL_TYPE.ADVANCED_TEXT_BOX &&
    isHiddenChildren &&
    !isEditor &&
    !isFormChangesMode
  ) {
    return null;
  }

  return (
    <FormInputChangesWrapper id={id} {...formChangesModeProps}>
      <div
        style={{
          marginRight: inTable && 10,
          maxWidth: disableMaxWidth ? null : maxWidth,
          width: disableWidth ? null : width,
          flex: getFlexValue(width, inTable, controlType, inFieldGroup, isInHeader, parentType),
        }}
        ui-ta={getUITA('SSSegmentFieldSet')}
        data-ss-id={id}
      >
        {children}
      </div>
    </FormInputChangesWrapper>
  );
};

export default React.memo(FormInput);
